<div class="changepassword-container">
    <mat-card class="default-card">
        <mat-card-header>
            <mat-card-title>{{ 'ChangePassword.Title' | translate }}</mat-card-title>
        </mat-card-header>

        @if (changePasswordForm) {
            <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
                <mat-card-content>
                    <app-password-policy [securityPolicy]="securityPolicy"></app-password-policy>
                    <div class="changepassword-form">
                        <mat-form-field appearance="outline" style="width: 200px">
                            <mat-label>{{ 'ChangePassword.InputSecurityCodePlaceholder' | translate }}</mat-label>
                            <input
                                [type]="hideSecurityCode ? 'password' : 'text'"
                                matInput
                                placeholder="{{ 'ChangePassword.InputSecurityCodePlaceholder' | translate }}"
                                formControlName="securityCode"
                                required />
                            <button
                                mat-icon-button
                                matSuffix
                                (click)="hideSecurityCode = !hideSecurityCode"
                                [attr.aria-label]="'Hide password'"
                                [attr.aria-pressed]="hideSecurityCode"
                                type="button">
                                <mat-icon>{{ hideSecurityCode ? 'visibility_off' : 'visibility' }}</mat-icon>
                            </button>
                            @if (changePasswordForm?.get('securityCode').hasError('required')) {
                                <mat-error>{{ 'ChangePassword.SecurityCodeRequired' | translate }}</mat-error>
                            }
                            @if (changePasswordForm?.get('securityCode').hasError('pattern')) {
                                <mat-error>{{ 'ChangePassword.SecurityCodePattern' | translate }}</mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field style="width: 300px">
                            <input
                                [type]="hideNewPassword ? 'password' : 'text'"
                                matInput
                                placeholder="{{ 'ChangePassword.InputNewPasswordPlaceholder' | translate }}"
                                formControlName="newPassword"
                                required />
                            <button
                                mat-icon-button
                                matSuffix
                                (click)="hideNewPassword = !hideNewPassword"
                                [attr.aria-label]="'Hide password'"
                                [attr.aria-pressed]="hideNewPassword"
                                type="button">
                                <mat-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                            </button>
                            @if (changePasswordForm?.get('newPassword').hasError('required')) {
                                <mat-error>{{ 'ChangePassword.InputPasswordErrorMessage' | translate }}</mat-error>
                            }
                            @if (changePasswordForm?.get('newPassword').hasError('passwordLength')) {
                                <mat-error>
                                    {{
                                        'ChangePassword.PasswordLength'
                                            | translate
                                                : { passwordMinCasesLength: securityPolicy.passwordMinCasesLength, passwordMaxCasesLength: securityPolicy.passwordMaxCasesLength }
                                    }}
                                </mat-error>
                            }
                            @if (changePasswordForm?.get('newPassword').hasError('minDigitsLength')) {
                                <mat-error>
                                    {{ 'ChangePassword.PasswordMinDigitsLength' | translate: { passwordMinDigitsLength: securityPolicy.passwordMinDigitsLength } }}
                                </mat-error>
                            }
                            @if (changePasswordForm?.get('newPassword').hasError('minUpperCasesLength')) {
                                <mat-error>
                                    {{ 'ChangePassword.PasswordMinUpperCasesLength' | translate: { passwordMinUpperCasesLength: securityPolicy.passwordMinUpperCasesLength } }}
                                </mat-error>
                            }
                            @if (changePasswordForm?.get('newPassword').hasError('minLowerCasesLength')) {
                                <mat-error>
                                    {{ 'ChangePassword.PasswordMinLowerCasesLength' | translate: { passwordMinLowerCasesLength: securityPolicy.passwordMinLowerCasesLength } }}
                                </mat-error>
                            }
                            @if (changePasswordForm?.get('newPassword').hasError('minSpecialCasesLength')) {
                                <mat-error>
                                    {{
                                        'ChangePassword.PasswordSpecialCases'
                                            | translate
                                                : {
                                                      passwordMinSpecialCasesLength: securityPolicy.passwordMinSpecialCasesLength,
                                                      passwordSpecialCases: securityPolicy.passwordSpecialCases,
                                                  }
                                    }}
                                </mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field style="width: 300px">
                            <input
                                [type]="hideNewConfirmedPassword ? 'password' : 'text'"
                                matInput
                                placeholder="{{ 'ChangePassword.InputNewConfirmedPasswordPlaceholder' | translate }}"
                                formControlName="newConfirmedPassword"
                                required />
                            <button
                                mat-icon-button
                                matSuffix
                                (click)="hideNewConfirmedPassword = !hideNewConfirmedPassword"
                                [attr.aria-label]="'Hide password'"
                                [attr.aria-pressed]="hideNewConfirmedPassword"
                                type="button">
                                <mat-icon>{{ hideNewConfirmedPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                            </button>
                            @if (changePasswordForm?.get('newConfirmedPassword').hasError('required')) {
                                <mat-error>{{ 'ChangePassword.InputPasswordErrorMessage' | translate }}</mat-error>
                            }
                            @if (changePasswordForm?.get('newConfirmedPassword').hasError('passwordLength')) {
                                <mat-error>
                                    {{
                                        'ChangePassword.PasswordLength'
                                            | translate
                                                : { passwordMinCasesLength: securityPolicy.passwordMinCasesLength, passwordMaxCasesLength: securityPolicy.passwordMaxCasesLength }
                                    }}
                                </mat-error>
                            }
                            @if (changePasswordForm?.get('newConfirmedPassword').hasError('minDigitsLength')) {
                                <mat-error>
                                    {{ 'ChangePassword.PasswordMinDigitsLength' | translate: { passwordMinDigitsLength: securityPolicy.passwordMinDigitsLength } }}
                                </mat-error>
                            }
                            @if (changePasswordForm?.get('newConfirmedPassword').hasError('minUpperCasesLength')) {
                                <mat-error>
                                    {{ 'ChangePassword.PasswordMinUpperCasesLength' | translate: { passwordMinUpperCasesLength: securityPolicy.passwordMinUpperCasesLength } }}
                                </mat-error>
                            }
                            @if (changePasswordForm?.get('newConfirmedPassword').hasError('minLowerCasesLength')) {
                                <mat-error>
                                    {{ 'ChangePassword.PasswordMinLowerCasesLength' | translate: { passwordMinLowerCasesLength: securityPolicy.passwordMinLowerCasesLength } }}
                                </mat-error>
                            }
                            @if (changePasswordForm?.get('newConfirmedPassword').hasError('minSpecialCasesLength')) {
                                <mat-error>
                                    {{
                                        'ChangePassword.PasswordSpecialCases'
                                            | translate
                                                : {
                                                      passwordMinSpecialCasesLength: securityPolicy.passwordMinSpecialCasesLength,
                                                      passwordSpecialCases: securityPolicy.passwordSpecialCases,
                                                  }
                                    }}
                                </mat-error>
                            }
                        </mat-form-field>
                        @if (
                            changePasswordForm?.get('newPassword').value.length >= securityPolicy.passwordMinCasesLength &&
                            changePasswordForm?.get('newConfirmedPassword').value.length >= securityPolicy.passwordMinCasesLength &&
                            changePasswordForm?.get('newPassword').value !== changePasswordForm?.get('newConfirmedPassword').value
                        ) {
                            <div class="error-container">
                                <mat-error>{{ 'ChangePassword.PasswordNotIdentical' | translate }}</mat-error>
                            </div>
                        }
                    </div>
                </mat-card-content>
                <mat-card-actions>
                    <button mat-stroked-button class="accent-button" type="button" (click)="cancel()">{{ 'ChangePassword.CancelButton' | translate }}</button>
                    <button
                        mat-raised-button
                        class="accent-button"
                        [disabled]="
                            (changePasswordForm?.valid && changePasswordForm?.get('newPassword').value !== changePasswordForm?.get('newConfirmedPassword').value) ||
                            (!changePasswordForm?.valid &&
                                (changePasswordForm?.get('newPassword').value.length === 0 || changePasswordForm?.get('newConfirmedPassword').value.length === 0)) ||
                            (!changePasswordForm?.valid &&
                                changePasswordForm?.get('newPassword').value.length > 0 &&
                                changePasswordForm?.get('newConfirmedPassword').value.length > 0)
                        "
                        type="submit">
                        {{ 'ChangePassword.SubmitButton' | translate }}
                    </button>
                </mat-card-actions>
            </form>
        }
    </mat-card>
</div>
